import dayjs from "dayjs";

import Tag, { TagVariant } from "components/ui/tag/Tag";
import { toHumanRelativeDateFromNow } from "lib/utils/relative_time";

type ReviewStatus = "overdue" | "due" | "fresh" | "none";

export function getReviewStatus(reviewDueDate: string | null | undefined): ReviewStatus {
  if (!reviewDueDate) return "none";

  const now = dayjs();
  const dueDate = dayjs(reviewDueDate);

  if (now.isSame(dueDate) || now.isAfter(dueDate)) return "overdue";
  if (now.isAfter(dueDate.subtract(14, "day"))) return "due";
  return "fresh";
}

function getLabel(status: ReviewStatus, reviewDueDate: string): string {
  const relative = toHumanRelativeDateFromNow(reviewDueDate);
  if (status === "overdue") {
    return `overdue ${relative.replace(" ago", "")}`;
  }
  if (status === "due") {
    return `due ${relative}`;
  }
  return "fresh";
}

const STATUS_VARIANT: Record<Exclude<ReviewStatus, "none">, TagVariant> = {
  overdue: "error",
  due: "warning",
  fresh: "success",
};

type Props = {
  reviewDueDate: string | null | undefined;
};

export default function ReviewStatusTag({ reviewDueDate }: Props) {
  const status = getReviewStatus(reviewDueDate);

  if (status === "none") return null;

  return <Tag variant={STATUS_VARIANT[status]} label={getLabel(status, reviewDueDate as string)} />;
}
